import { useCallback, useState } from 'react';
import { Keyboard } from 'react-native';
import { useSharedValue } from 'react-native-reanimated';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { SelectAssetForSwitchModal } from '../components/SelectAssetForSwitchModal';
import { activateFundPicker } from './useFundPickerStore';
import { selectHasMultiplePositions } from './selectors';
const useAssetSwitchPicker = (fromAssetId, toAssetId, onSelectToAssetId) => {
    const scrollSharedValue = useSharedValue(0);
    const navigation = useMainStackNavigation();
    const [isPickerOpen, setIsPickerOpen] = useState(false);
    const hasMultiplePositions = useAppSelector(selectHasMultiplePositions);
    const onCloseModal = useCallback(() => {
        setIsPickerOpen(false);
        scrollSharedValue.value = 0;
    }, [scrollSharedValue]);
    const onNavigateToDiscoverToPickFund = useCallback(() => {
        activateFundPicker(toAssetId ? [toAssetId] : undefined, { mode: 'single', ignoreFunds: [fromAssetId] });
        navigation.navigate('InvestDiscover', { start: 'readyMade' });
    }, [fromAssetId, toAssetId]);
    const onExploreFullFundList = useCallback(() => {
        SelectAssetForSwitchModal.hide(() => {
            onCloseModal();
            onNavigateToDiscoverToPickFund();
        });
    }, [onCloseModal, onNavigateToDiscoverToPickFund]);
    const onPress = useCallback(() => {
        Keyboard.dismiss();
        if (hasMultiplePositions) {
            setIsPickerOpen(true);
            SelectAssetForSwitchModal.show(fromAssetId, toAssetId, onSelectToAssetId, scrollSharedValue, onCloseModal, onExploreFullFundList);
        }
        else {
            onNavigateToDiscoverToPickFund();
        }
    }, [
        fromAssetId,
        hasMultiplePositions,
        onCloseModal,
        onExploreFullFundList,
        onNavigateToDiscoverToPickFund,
        onSelectToAssetId,
        scrollSharedValue,
        toAssetId,
    ]);
    return { isPickerOpen, onPress };
};
export default useAssetSwitchPicker;
